import { useTranslation } from 'react-i18next';

import { CustomTypography } from '@/components/CustomTypography';
import { prepareSearchQueryFromDrugName } from '@/components/nomenclature/helpers';
import {
  DataGrid,
  DataGridContainer,
  DataGridTitle,
  DataGridToolbar,
  type DataGridSelectionParams,
} from '@/components/ReactDataGrid';

import { useReconciliationBindingActions } from '../reconciliation-binding.store';
import { useUnboundDrugs, type ReconciliationUnboundBinding } from '../useLoadUnboundDrugs';

export const ReconciliationUnboundDrugsList = () => {
  const { t } = useTranslation('orders-page');
  const { data: unboundDrugs = [], isLoading } = useUnboundDrugs();
  const { setSelectedUnboundDrug, setNomenclatureSearchQuery } = useReconciliationBindingActions();

  const handleSelectionChange = ({ data }: DataGridSelectionParams<ReconciliationUnboundBinding>) => {
    if (data) {
      const drug = data as ReconciliationUnboundBinding;
      setSelectedUnboundDrug(drug);
      setNomenclatureSearchQuery(prepareSearchQueryFromDrugName(drug.name));
    }
  };

  return (
    <DataGridContainer>
      <DataGridToolbar>
        <DataGridTitle>{t('reconciliation.binding.unbound-title')}</DataGridTitle>
      </DataGridToolbar>
      <DataGrid
        idProperty="id"
        loading={isLoading}
        dataSource={unboundDrugs}
        onSelectionChange={handleSelectionChange}
        shareSpaceOnResize
        columns={[
          {
            name: 'name',
            defaultFlex: 2,
            minWidth: 250,
            header: t('reconciliation.binding.columns.product-name'),
            render: ({ value }: { value: string }) => (
              <CustomTypography noWrap lineClamp={2} component="p" variant="inherit" title={value}>
                {value}
              </CustomTypography>
            ),
          },
          {
            name: 'maker_name',
            defaultFlex: 1,
            minWidth: 200,
            header: t('reconciliation.binding.columns.manufacturer'),
            render: ({ value }: { value: string }) => (
              <CustomTypography noWrap lineClamp={2} component="p" variant="inherit" title={value}>
                {value}
              </CustomTypography>
            ),
          },
        ]}
      />
    </DataGridContainer>
  );
};
